import '@theme/gsap'
import { useReduced } from '@theme/maths'

const FRAME_SELECTOR = '[data-media-reveal]'
const CURTAIN_SELECTOR = '.media-reveal__curtain'
const FILL_SELECTOR = '.media-fill'
const ARMED_STATE = 'armed'

const REVEAL = {
  duration: 1.47,
  start: 'top 90%',
  fromScale: 1.5,
  ease: 'power3.inOut'
}

/** @type {WeakSet<HTMLElement>} */
const revealedFrames = new WeakSet()

/**
 * @param {HTMLElement | Document} scope
 * @returns {HTMLElement[]}
 */
function getRevealFrames(scope) {
  const frames = Array.from(scope.querySelectorAll(FRAME_SELECTOR))
  if (scope instanceof HTMLElement && scope.matches(FRAME_SELECTOR)) {
    frames.unshift(scope)
  }
  return frames.filter((frame) => frame instanceof HTMLElement)
}

/**
 * @param {HTMLElement} frame
 * @returns {void}
 */
function armFrame(frame) {
  frame.dataset.mediaReveal = ARMED_STATE
}

/**
 * @param {HTMLElement} frame
 * @returns {void}
 */
function revealFrame(frame) {
  const gsap = window.gsap
  const curtain = frame.querySelector(CURTAIN_SELECTOR)
  const fill = frame.querySelector(FILL_SELECTOR)

  armFrame(frame)

  const timeline = gsap.timeline({
    scrollTrigger: { trigger: frame, start: REVEAL.start, once: true }
  })

  if (curtain) {
    timeline.fromTo(
      curtain,
      { scaleY: 1 },
      { scaleY: 0, duration: REVEAL.duration, ease: REVEAL.ease },
      0
    )
  }

  if (fill) {
    timeline.fromTo(
      fill,
      { scale: REVEAL.fromScale },
      { scale: 1, duration: REVEAL.duration, ease: REVEAL.ease },
      0
    )
  }
}

/**
 * @param {HTMLElement | Document} [scope]
 * @returns {void}
 */
function init(scope = document) {
  const gsap = window.gsap
  if (!(gsap && window.ScrollTrigger)) return
  if (useReduced()) return

  for (const frame of getRevealFrames(scope)) {
    if (revealedFrames.has(frame)) continue
    revealedFrames.add(frame)
    revealFrame(frame)
  }
}

/** @param {Event} event */
function onSectionLoad(event) {
  if (event.target instanceof HTMLElement) init(event.target)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init(), { once: true })
} else {
  init()
}

document.addEventListener('shopify:section:load', onSectionLoad)
